module.exports = __webpack_public_path__ + "img/card2.60349484.png";